/* --------------------------------------------------------------------------
	Charts
-------------------------------------------------------------------------- */

	"use strict";

    var $ = jQuery;
    import "chart.js";

    function loadChart(node, config) {
        config = Object.assign(
            {
                type: 'line',
                data: [],
                options: {}
            },
            config
        );

        new Chart(node, config);
    }

    function loadCharts() {
        $('.js-chart').each(function () {
            var $node = $(this);

            try {
                var json = $node.find('[data-script]');
                var canvas = $node.find('[data-canvas]');

                if (!json.length || !canvas.length) return;

                json = JSON.parse(json.text().trim());

                loadChart(canvas, json);
            } catch (e) {
                // console.log(e);

                $node.hide();
            }
        });
    }

    function setGlobalChartSettings() {
        // platform
        Chart.platform.disableCSSInjection = true;

        // defaults
        Chart.defaults.global.legend.align = 'start';
        Chart.defaults.global.defaultFontFamily =
            '"Graphik-Regular", sans-serif';
        Chart.defaults.global.defaultFontSize = 14;
        Chart.defaults.global.defaultFontColor = '#000';
        Chart.defaults.global.defaultColor = '#000';
        Chart.defaults.global.aspectRatio = 2 * 0.8;

        // legend
        Chart.defaults.global.legend.labels.boxWidth = 16;

        // scaleLabels
        Chart.defaults.scale.scaleLabel.display = true;
        Chart.defaults.scale.scaleLabel.fontFamily =
            '"Graphik-Bold", sans-serif';

        // hooks
        Chart.Legend.prototype.afterFit = function () {
            this.height = this.height + 25;
        };
        
        // doughnut
        Chart.defaults.doughnut.aspectRatio = 2;
        Chart.defaults.doughnut.legend.position = 'left';
        Chart.defaults.doughnut.legend.align = 'center';
    }

    function initChart() {
        if ($('.js-chart').length == 0) return;
        Chart = window.Chart;
        setGlobalChartSettings();
        loadCharts();
    }

    $(initChart);
